import React from 'react';
import classNames from 'classnames/bind';
import { Button } from '@carnica/ui-kit';
import { IconCloseRoundStroked } from '@carnica/graphics';
import { Metric } from "../../../../metric";
import style from "./styles.pcss";
var cn = classNames.bind(style);
export var ActionBar = function ActionBar(_ref) {
  var onCloseButtonClick = _ref.onCloseButtonClick;
  return /*#__PURE__*/React.createElement(Metric, {
    asChild: true,
    events: {
      headerMetric: ['handleCloseRegionModalClick']
    },
    mode: "click",
    "data-t-id": "components-ActionBar"
  }, /*#__PURE__*/React.createElement(Button, {
    className: cn('action-button'),
    iconLeft: IconCloseRoundStroked,
    onClick: onCloseButtonClick,
    onlyIcon: true,
    size: "m",
    view: "tertiary",
    "data-t-id": "components-ActionBar"
  }));
};